<template>
  <div v-show="$route.meta.navShow">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"
        ><i class="el-icon-s-home"></i>当前位置：天科云创</el-breadcrumb-item
      >
      <el-breadcrumb-item v-for="(item,index) in $route.matched" :key="index">
        {{ item.name }}
        </el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "BreadList",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
::v-deep.el-breadcrumb {
  font-size: 20px;
  margin: 10px;
}
</style>